import AuthorHome from 'components/AuthorHome';
import {useRouter} from 'next/router';
import {getAuthorAsSlugOnly} from 'utils/sanity.client';
import {getAllAuthorPosts} from 'utils/blog';

const AuthorPage = ({author}) => {
  const router = useRouter();

  // If the page is not yet generated, this will be displayed
  // initially until getStaticProps() finishes running
  if (router.isFallback) {
    return <div>Loading...</div>;
  }

  if (!author) {
    // Handling an edge case where this page is prerendered with undefined props
    // during the build.
    return null;
  }

  return <AuthorHome author={author} />;
};

export async function getStaticPaths() {
  const authors = await getAuthorAsSlugOnly();

  const paths = authors.map(author => ({
    params: {slug: author.slug},
  }));

  return {
    paths,
    fallback: true,
  };
}

export async function getStaticProps(context) {
  // It's important to default the slug so that it doesn't return "undefined"
  const {slug = ''} = context.params;

  const author = await getAllAuthorPosts(slug);

  return {
    props: {
      author,
    },
    revalidate: 60,
  };
}

export default AuthorPage;
